/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuremovefulltitle3Inputs */

const en_menuremovefulltitle3 = /** @type {(inputs: Menuremovefulltitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove the menu?`)
};

const de_menuremovefulltitle3 = /** @type {(inputs: Menuremovefulltitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speisekarte entfernen?`)
};

/**
* | output |
* | --- |
* | "Remove the menu?" |
*
* @param {Menuremovefulltitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuremovefulltitle3 = /** @type {((inputs?: Menuremovefulltitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuremovefulltitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuremovefulltitle3(inputs)
	return de_menuremovefulltitle3(inputs)
});
export { menuremovefulltitle3 as "menuRemoveFullTitle" }